/* GiftInOne Editor 2.3: reuse the existing signed orders/ upload pipeline.
 * Sources + manifest + preview are committed before an automatic-production trigger.
 * Manual layer designs save these files without requesting or promising an HD file.
 * Automatic production runs independently; the browser never polls its output.
 */
(function (window) {
  'use strict';
  if (window.GIOEditorV2DesignUpload) return;
  var SCHEMA = 'gio-design-v1';
  var MANUAL_SCHEMA = 'gio-design-manual-v1';
  // Human-readable order backup. The design document remains the production
  // source; these private properties require no extra upload or HD wait.
  function textMetadata(text, id, kind) {
    var metadata = {}, fontId = text.fontId || text.font || '', fonts = window.GIOEditorV2Fonts;
    var labels = { sans: 'Sans', serif: 'Serif', 'great-vibes': 'Great Vibes', pacifico: 'Pacifico', caveat: 'Caveat', 'bebas-neue': 'Bebas Neue', bangers: 'Bangers', 'elegance-serif': 'Elegance Serif' };
    if (id) metadata.id = String(id);
    if (kind) metadata.kind = String(kind);
    if (fontId) {
      metadata.fontId = String(fontId);
      // An unavailable font renderer must not erase the user's selection or
      // claim that a fallback was successfully printed.
      metadata.fontName = fonts && typeof fonts.describe === 'function' ? fonts.describe(fontId).fontName : labels[fontId] || text.fontName || String(fontId);
    } else if (typeof text.fontName === 'string' && text.fontName) metadata.fontName = text.fontName;
    if (Array.isArray(text.renderedFontNames) && text.renderedFontNames.length && text.renderedFontNames.every(function (name) { return typeof name === 'string' && name.length; })) {
      metadata.renderedFontNames = text.renderedFontNames.slice();
      metadata.renderingFallback = text.renderingFallback === true;
    }
    return metadata;
  }
  function customerTexts(data) {
    data = data || {};
    var entries = [], seen = Object.create(null);
    function keep(text, kind, index) {
      if (!text || typeof text !== 'object') return;
      var value = typeof text.value === 'string' ? text.value : typeof text.text === 'string' ? text.text : '';
      if (!value.trim()) return;
      var id = String(text.fieldId || text.id || '');
      if (kind === 'intent' && id && seen[id]) return;
      if (id) seen[id] = true;
      entries.push(Object.assign({ value: value }, textMetadata(text, id || kind + '-' + (index + 1), kind)));
    }
    (Array.isArray(data.texts) ? data.texts : []).forEach(function (text, i) { keep(text, 'text', i); });
    (Array.isArray(data.freeTexts) ? data.freeTexts : []).forEach(function (text, i) { keep(text, 'extra-text', i); });
    (data.intent && Array.isArray(data.intent.texts) ? data.intent.texts : []).forEach(function (text, i) { keep(text, 'intent', i); });
    var notes = data.intent && data.intent.notes || data.manualNotes;
    if (typeof notes === 'string' && notes.trim()) entries.push({ id: 'production-note', kind: 'production-note', value: notes });
    return entries;
  }
  function withCustomerTexts(result, design) {
    result.customerTexts = customerTexts(design.manifestDesign);
    return result;
  }
  function customerTextProperties(result, index) {
    var props = {}, area = String(index);
    if (!/^\d{1,3}$/.test(area) || !result) return props;
    var entries = Array.isArray(result.customerTexts) ? result.customerTexts : customerTexts(result.scene);
    function addParts(prefix, label, value, number) {
      var parts = [], part = '', bytes = 0;
      // Whole Unicode code points; even with the label each property remains
      // below 255 UTF-8 bytes. Text and metadata share the same field number.
      Array.from(value).forEach(function (ch) {
        var cp = ch.codePointAt(0), size = cp < 128 ? 1 : cp < 2048 ? 2 : cp < 65536 ? 3 : 4;
        if (bytes + size > 200) { parts.push(part); part = ''; bytes = 0; }
        part += ch; bytes += size;
      });
      if (part) parts.push(part);
      parts.forEach(function (chunk, partIndex) {
        // This label also keeps URL-looking customer data away from legacy
        // file handling; the webhook explicitly reserves both property names.
        props[prefix + area + '_' + number + '_' + (partIndex + 1)] =
          label + ' ' + number + ' (' + (partIndex + 1) + '/' + parts.length + '):\n' + chunk;
      });
    }
    entries.forEach(function (entry, textIndex) {
      if (!entry || typeof entry.value !== 'string' || !entry.value.trim()) return;
      addParts('_CustomerText', 'Text', entry.value, textIndex + 1);
      var metadata = textMetadata(entry, entry.id || entry.fieldId, entry.kind);
      if (Object.keys(metadata).length) addParts('_CustomerTextMeta', 'Text meta', JSON.stringify(metadata), textIndex + 1);
    });
    return props;
  }
  function fail(message) { throw new Error(message); }
  function dimensions(value) {
    return value && Number.isInteger(value.width) && Number.isInteger(value.height) && value.width > 0 && value.height > 0 &&
      value.width <= 16000 && value.height <= 16000 && value.width * value.height <= 200000000;
  }
  function geometryError(message) {
    var error = new Error(message || 'Your product size changed. Please review your design again.');
    error.code = 'GIO_OPTIONS_CHANGED';
    throw error;
  }
  // Bind the reviewed fixed crop to its product variant. Do not infer this
  // metadata from whichever variant happens to be selected after uploading.
  function validateProductGeometry(value, output) {
    var allowed = ['schema', 'productId', 'productHandle', 'variantId', 'themeId', 'mode', 'ratio'];
    if (!value || typeof value !== 'object' || Array.isArray(value) || value.schema !== 'gio-product-geometry-v1' || value.mode !== 'fixed' ||
        Object.keys(value).some(function (key) { return allowed.indexOf(key) === -1; }) ||
        !/^[0-9]{1,20}$/.test(value.productId || '') || typeof value.productId !== 'string' ||
        !/^[0-9]{1,20}$/.test(value.variantId || '') || typeof value.variantId !== 'string' ||
        typeof value.productHandle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(value.productHandle) ||
        (value.themeId !== undefined && (typeof value.themeId !== 'string' || !/^[0-9]{1,20}$/.test(value.themeId))) ||
        typeof value.ratio !== 'number' || !Number.isFinite(value.ratio) || value.ratio <= 0) {
      geometryError('The selected product size could not be verified. Please reopen your design.');
    }
    var core = window.GIOCropGeometryCore;
    if (!core || typeof core.canonicalOutput !== 'function') geometryError('The product size tools have not loaded. Please refresh this page.');
    var expected = core.canonicalOutput(value.ratio);
    if (!expected || !dimensions(output) || output.width !== expected.width || output.height !== expected.height) {
      geometryError('Your design shape does not match the selected product size. Please review the crop again.');
    }
    var result = {};
    allowed.forEach(function (key) { if (value[key] !== undefined) result[key] = value[key]; });
    return result;
  }
  function rect(value) {
    return value && ['x', 'y', 'width', 'height'].every(function (name) {
      return typeof value[name] === 'number' && isFinite(value[name]) && value[name] >= (name === 'x' || name === 'y' ? 0 : 0.000001) && value[name] <= 1;
    }) && value.x + value.width <= 1.000001 && value.y + value.height <= 1.000001;
  }
  function artworkUrl(value) {
    try {
      if (typeof value !== 'string' || !value || value.length > 4096) return '';
      // Check the supplied path before URL parsing can normalize dot segments.
      var rawPath = value.split(/[?#]/)[0], decoded = decodeURIComponent(rawPath);
      if (/%(?:2f|5c|25)/i.test(rawPath) || /[\\\u0000-\u001f\u007f]/.test(decoded) || decoded.indexOf('..') !== -1) return '';
      var url = new URL(value, window.location.href);
      var shopify = url.hostname === 'cdn.shopify.com' && url.pathname.indexOf('/s/files/1/0431/4847/6573/files/') === 0;
      var storefront = [window.location.hostname, 'giftinone.com', 'www.giftinone.com'].indexOf(url.hostname) !== -1 && url.pathname.indexOf('/cdn/shop/files/') === 0;
      var bucket = (url.hostname === 'static.giftinone.com' || /^giftinone\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/.test(url.hostname)) && /^\/backimg\/[^/]+$/.test(url.pathname);
      if (url.protocol !== 'https:' || url.username || url.password || url.port || (!shopify && !storefront && !bucket)) return '';
      url.hash = ''; return url.href;
    } catch (_) { return ''; }
  }
  function validate(design) {
    var data = design && design.manifestDesign;
    if (!data || !dimensions(data.output) || !/^#[0-9a-f]{6}$/i.test(data.background)) fail('This design has invalid dimensions or background. Please reopen it.');
    var productionMode = data.productionMode === undefined ? 'automatic' : data.productionMode;
    if (productionMode !== 'automatic' && productionMode !== 'manual') fail('This design has an invalid production mode. Please reopen it.');
    if (productionMode === 'manual') {
      var previewOverlay = data.previewOverlay;
      if (data.overlay != null || !previewOverlay || !dimensions(previewOverlay) || !artworkUrl(previewOverlay.sourceUrl)
          || Object.keys(previewOverlay).some(function (key) { return ['sourceUrl', 'width', 'height'].indexOf(key) === -1; })) {
        fail('The product preview is not configured. Please reopen the design.');
      }
    } else if (data.previewOverlay !== undefined) {
      fail('Preview artwork cannot be used for automatic production. Please reopen the design.');
    }
    if (!design.previewBlob || !design.previewBlob.size || !Array.isArray(design.files) || !design.files.length || design.files.length > 6) fail('Please add photos to your design.');
    var total = 0;
    design.files.forEach(function (file) {
      if (!file || !file.size || file.size > 100 * 1024 * 1024) fail('Each photo must be smaller than 100 MB.');
      total += file.size;
    });
    if (total > 240 * 1024 * 1024) fail('These photos are too large together. Please use smaller files (240 MB total maximum).');
    if (!Array.isArray(data.photos) || !data.photos.length || data.photos.length > 6) fail('A design must contain one to six photos.');
    data.photos.forEach(function (photo) {
      if (!Number.isInteger(photo.sourceIndex) || photo.sourceIndex < 0 || photo.sourceIndex >= design.files.length || !rect(photo.rect) || !rect(photo.crop) || [0, 90, 180, 270].indexOf(photo.rotate || 0) === -1) fail('Please check the photo crop and try saving again.');
    });
    if (!Array.isArray(data.texts) || data.texts.length > 8) fail('A design can contain up to eight text boxes.');
    var totalPath = 0;
    data.texts.forEach(function (text) {
      if (!rect(text.rect) || !/^#[0-9a-f]{6}$/i.test(text.fill) || typeof text.path !== 'string' || !text.path.length || text.path.length > 250000 || !/^[MmLlHhVvCcSsQqTtAaZzEe0-9+.,\-\s]+$/.test(text.path) || !Array.isArray(text.viewBox) || text.viewBox.length !== 4) fail('Please check your text and try saving again.');
      var numbers = text.path.match(/[+-]?(?:\d*\.\d+|\d+\.?\d*)(?:[eE][+-]?\d+)?/g) || [];
      if (numbers.length > 40000 || numbers.some(function (n) { return !isFinite(Number(n)) || Math.abs(Number(n)) > 1000000; }) || (text.path.match(/[MmLlHhVvCcSsQqTtAaZz]/g) || []).length > 16000) fail('This text is too detailed. Please shorten it.');
      if (text.viewBox.some(function (n, i) { return typeof n !== 'number' || !isFinite(n) || n < (i < 2 ? -100000 : 0.000001) || n > 100000; })) fail('This text cannot be printed. Please shorten it.');
      totalPath += text.path.length;
      if (totalPath > 1800000) fail('This design has too much text. Please shorten it before saving.');
    });
    if (data.overlay != null) {
      var filename = data.overlay.filename;
      if (typeof data.overlay !== 'object' || Array.isArray(data.overlay) || Object.keys(data.overlay).some(function (key) { return key !== 'filename'; })
          || typeof filename !== 'string' || !filename || filename.length > 240 || /[\u0000-\u001f\u007f\\/]/.test(filename) || filename.indexOf('..') !== -1) {
        fail('The production artwork is not configured. Please contact support.');
      }
    }
    if (new Blob([JSON.stringify(data)]).size > 2 * 1024 * 1024 - 4096) fail('This design is too complex. Please shorten the text.');
    return data;
  }
  function id() {
    if (!window.crypto || !window.crypto.getRandomValues) fail('Please use a secure browser connection to save your design.');
    var bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
    return 'gio-' + Date.now().toString(36) + '-' + Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }
  function uploadFailure(reason) { var error = new Error(reason && reason.message || 'Personalization upload is unavailable.'); error.code = 'GIO_UPLOAD_UNAVAILABLE'; return error; }
  function put(file, filename, metadata, progress) {
    return new Promise(function (resolve, reject) {
      if (typeof window.uploadToS3 !== 'function') { reject(uploadFailure()); return; }
      var settled = false, timer, handle;
      function clear() { window.clearTimeout(timer); }
      function done(url) { if (!settled) { settled = true; clear(); url ? resolve(url) : reject(uploadFailure()); } }
      function error(reason) { if (!settled) { settled = true; clear(); reject(uploadFailure(reason)); } }
      timer = window.setTimeout(function () { error(new Error('Personalization upload timed out.')); try { if (handle && handle.abort) handle.abort(); } catch (_) {} }, 60000);
      try {
        var pending = handle = window.uploadToS3({ blob: file, fileName: filename, cropData: metadata || {}, progressFn: progress, successFn: done, errorFn: error });
        if (pending && typeof pending.then === 'function') pending.then(function (url) { if (!settled) done(url); }, error);
      } catch (reason) { error(reason); }
    });
  }
  async function saveInternal(design, options) {
    if (design && design.manifestDesign && design.manifestDesign.schema === 'gio-layered-design-v1') {
      if (!window.GIOEditorV2LayeredUpload) throw uploadFailure();
      return withCustomerTexts(await window.GIOEditorV2LayeredUpload.save(design, options), design);
    }
    if (design && design.manifestDesign && ['gio-template-v1', 'gio-universal-v1', 'gio-file-design-v1'].indexOf(design.manifestDesign.schema) !== -1) {
      if (!window.GIOEditorV2TemplateUpload) { var unavailable=new Error('The template upload service has not loaded.');unavailable.code='TEMPLATE_UPLOAD_UNAVAILABLE';throw unavailable; }
      return withCustomerTexts(await window.GIOEditorV2TemplateUpload.save(design, options), design);
    }
    options = options || {};
    var progress = typeof options.onProgress === 'function' ? options.onProgress : function () {};
    var data = validate(design), auth = window.GiftInOneAwsUploadAuth;
    var productGeometry = options.productGeometry == null ? null : validateProductGeometry(options.productGeometry, data.output);
    if (productGeometry && (data.productionMode === 'manual' || data.overlay != null)) {
      geometryError('This product artwork cannot use an ordinary photo crop. Please reopen your design.');
    }
    var reviewedOutput = JSON.stringify(data.output);
    async function assertUnchanged() {
      if (typeof options.beforeCommit === 'function') await options.beforeCommit();
      if (!productGeometry) return;
      if (JSON.stringify(data.output) !== reviewedOutput) geometryError();
      validateProductGeometry(productGeometry, data.output);
      var geometry = window.GIOProductGeometry;
      if (!geometry || typeof geometry.assertCurrent !== 'function') geometryError('The product size tools have not loaded. Please refresh this page.');
      geometry.assertCurrent(window.GIOEditorV2Config, productGeometry);
    }
    await assertUnchanged();
    if (!auth || !auth.getUploadConfig || !auth.buildPublicUrl) throw uploadFailure();
    var config; try { config = auth.getUploadConfig(); if (String(config.uploadFolder).replace(/^\/+|\/+$/g, '') !== 'orders') throw new Error('Upload configuration unavailable.'); } catch (error) { throw uploadFailure(error); }
    var manual = data.productionMode === 'manual';
    var job = id(), originals = [], names = [], overlay = data.overlay || null, manifestUrl = '', previewUrl = '';
    function partial() { if (typeof options.onPartial === 'function') options.onPartial({ jobId: job, signature: options.signature, scene: design.scene, customerTexts: customerTexts(data),
      originalUrls: originals.slice(), uniqueOriginalUrls: originals.slice(), manifestUrl: manifestUrl, previewUrl: previewUrl, hdUrl: '', productionMode: 'manual', productionState: 'awaiting_assets' }); }
    partial();
    for (var i = 0; i < design.files.length; i += 1) {
      await assertUnchanged();
      var extension = auth.resolveSourceExtension ? auth.resolveSourceExtension(design.files[i]) : 'bin';
      if (!/^(jpg|jpeg|png|webp|heic|heif|avif|tif|tiff|gif|bmp|bin)$/i.test(extension)) fail('This photo format is not supported for printing. Please use JPG, PNG or WebP.');
      var name = job + '-photo-' + i + '.' + extension.toLowerCase(); names.push(name);
      progress('Uploading photo ' + (i + 1) + ' of ' + design.files.length + '…');
      originals.push(await put(design.files[i], name, {}, (function (index) {
        return function (percent) { progress('Uploading photo ' + (index + 1) + ' of ' + design.files.length + '… ' + Math.round(percent) + '%'); };
      }(i))));
      partial();
    }
    var manifest = { schema: manual ? MANUAL_SCHEMA : SCHEMA, jobId: job, background: data.background,
      photos: data.photos.map(function (photo) { return { key: 'orders/' + names[photo.sourceIndex], rect: photo.rect, crop: photo.crop, rotate: photo.rotate || 0 }; }),
      texts: data.texts, overlay: overlay };
    if (manual) {
      manifest.production = { mode: 'manual', reason: 'missing-production-overlay' };
      manifest.referenceCanvas = data.output;
      manifest.previewOverlay = { sourceUrl: artworkUrl(data.previewOverlay.sourceUrl), width: data.previewOverlay.width, height: data.previewOverlay.height };
    } else {
      manifest.output = data.output;
      if (productGeometry) manifest.productGeometry = productGeometry;
    }
    var json = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    if (json.size > 2 * 1024 * 1024) fail('This design is too complex. Please shorten the text and save again.');
    progress('Saving your design…');
    await assertUnchanged();
    manifestUrl = await put(json, job + '-design.json'); partial();
    await assertUnchanged();
    previewUrl = await put(design.previewBlob, job + '-preview.png'); partial();
    var hdUrl = '';
    if (!manual) {
      // One PNG pixel. Source photos are separate immutable objects.
      var binary = window.atob('iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIHWP4z8DwHwAFgAI/ScLbtAAAAABJRU5ErkJggg==');
      var pixels = new Uint8Array(binary.length); for (var b = 0; b < binary.length; b += 1) pixels[b] = binary.charCodeAt(b);
      await assertUnchanged();
      await put(new Blob([pixels], { type: 'image/png' }), 'needcrop-' + job + '-origin.png', {
        designkey: 'orders/' + job + '-design.json', hdkey: 'orders/' + job + '-hd.png', outputextension: 'png'
      });
      hdUrl = auth.buildPublicUrl(job + '-hd.png');
    }
    await assertUnchanged();
    progress('Your design is saved.');
    // An explicit production layer determines dimensions after server-side decode.
    // Manual files describe a reference canvas, never a generated HD image.
    var actual = manual || overlay ? null : data.output;
    return { schema: manifest.schema, jobId: job, scene: design.scene, previewUrl: previewUrl, hdUrl: hdUrl,
      manifestUrl: manifestUrl, productionMode: manual ? 'manual' : 'automatic', productionState: manual ? 'manual' : 'submitted', originalUrls: originals, sourceFiles: design.files, overlayUrl: '',
      signature: options.signature, customerTexts: customerTexts(data), outputWidth: actual ? actual.width : null, outputHeight: actual ? actual.height : null };
  }
  async function save(design, options) {
    options = options || {}; var partial = { scene: design && design.scene, signature: options.signature, originalUrls: [], productionMode: 'manual', productionState: 'awaiting_assets', customerTexts: customerTexts(design && design.manifestDesign) };
    var forwarded = Object.assign({}, options, { onPartial: function (value) { partial = withCustomerTexts(value, design); if (typeof options.onPartial === 'function') options.onPartial(partial); } });
    try { return await saveInternal(design, forwarded); }
    catch (error) { if (error && ['GIO_UPLOAD_UNAVAILABLE','TEMPLATE_UPLOAD_UNAVAILABLE'].indexOf(error.code) >= 0) error.partialResult = withCustomerTexts(error.partialResult || partial, design); throw error; }
  }
  window.GIOEditorV2DesignUpload = { save: save, validate: validate, validateProductGeometry: validateProductGeometry, customerTextProperties: customerTextProperties };
}(window));
